import { makeObservable } from 'mobx';

import type { TConstraints } from '@feathr/rachis';

import { MailrailBaseEmailCampaign } from './mailrail_email_base';
import type { IMailrailSingleSendEmailCampaign } from './types';

export class MailrailSingleSendEmailCampaign<
  T extends IMailrailSingleSendEmailCampaign = IMailrailSingleSendEmailCampaign,
> extends MailrailBaseEmailCampaign<T> {
  public override get constraints(): TConstraints<IMailrailSingleSendEmailCampaign> {
    return {
      ...super.constraints,
      // Single Sends run all at once, so they do not have end dates
      date_end: undefined,
      segments_included: {
        length: {
          minimum: 1,
          tooShort: '^Add at least one included group',
        },
        list: {
          presence: {
            allowEmpty: false,
            message: '^Finish selecting a group or remove the placeholder group.',
          },
        },
        duplicates: {
          maximum: 0,
          message: '^Groups must be unique.',
        },
      },
    };
  }

  constructor(attributes: Partial<T>) {
    super(attributes);

    makeObservable(this);
  }
}
